<div class="invitation-resolver-container">
  <div class="loading-content" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading .......</p>
  </div>
  
  <div class="error-content" *ngIf="error && !loading">
    <div class="error-icon">⚠️</div>
    <h2>Unable to Process Invitation</h2>
    <p>{{ error }}</p>
    <button class="retry-btn" (click)="ngOnInit()">Try Again</button>
  </div>
</div>